import { useEffect, useState } from 'react';
import * as logistaService from '@/services/logistaService';

const statusConfig = {
  trial: {
    icon: '⏳',
    title: 'Trial gratuito',
    color: 'border-amber-200 bg-amber-50',
    titleColor: 'text-amber-800',
  },
  active: {
    icon: '✅',
    title: 'Subscrição ativa',
    color: 'border-emerald-200 bg-emerald-50',
    titleColor: 'text-emerald-800',
  },
  past_due: {
    icon: '⚠️',
    title: 'Pagamento em atraso',
    color: 'border-red-200 bg-red-50',
    titleColor: 'text-red-800',
  },
  cancelled: {
    icon: '❌',
    title: 'Subscrição cancelada',
    color: 'border-edge bg-background',
    titleColor: 'text-fg',
  },
  expired: {
    icon: '🔒',
    title: 'Acesso expirado',
    color: 'border-red-200 bg-red-50',
    titleColor: 'text-red-800',
  },
};

export default function LogistaSubscriptionPage() {
  const [sub, setSub] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    logistaService.getSubscription()
      .then((r) => setSub(r.data.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="flex h-64 items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-accent border-t-transparent" />
      </div>
    );
  }

  const cfg = statusConfig[sub?.status] || statusConfig.trial;

  return (
    <div className="max-w-2xl space-y-6">
      <div>
        <h1 className="font-serif text-2xl font-black text-fg">Subscrição</h1>
        <p className="text-sm text-muted">Estado do teu plano na plataforma.</p>
      </div>

      {/* Status card */}
      <div className={`rounded-2xl border p-6 ${cfg.color}`}>
        <div className="flex items-start gap-4">
          <span className="text-4xl">{cfg.icon}</span>
          <div className="flex-1">
            <h2 className={`text-xl font-black ${cfg.titleColor}`}>{cfg.title}</h2>

            {sub?.status === 'trial' && (
              <div className="mt-2 space-y-1">
                <p className="text-amber-700">
                  <strong>{sub.trialDaysLeft} {sub.trialDaysLeft === 1 ? 'dia' : 'dias'}</strong> restantes no trial gratuito
                </p>
                <p className="text-sm text-amber-600">
                  Trial termina em {new Date(sub.trialEndsAt).toLocaleDateString('pt-PT')}
                </p>
              </div>
            )}

            {sub?.status === 'active' && sub.currentPeriodEnd && (
              <p className="mt-2 text-sm text-emerald-700">
                Próxima cobrança: <strong>{new Date(sub.currentPeriodEnd).toLocaleDateString('pt-PT')}</strong>
              </p>
            )}

            {(sub?.status === 'expired' || sub?.status === 'cancelled') && (
              <p className="mt-2 text-sm text-muted">
                O teu acesso está suspenso. Contacta-nos para reativar a subscrição.
              </p>
            )}
          </div>
        </div>
      </div>

      {/* Plan details */}
      <div className="rounded-2xl border border-edge bg-surface p-6 shadow-sm">
        <h2 className="mb-4 font-bold text-fg">Plano Hakken Logista</h2>
        <div className="flex items-baseline gap-1">
          <span className="text-4xl font-black text-fg">19,99€</span>
          <span className="text-muted">/mês</span>
        </div>
        <ul className="mt-4 space-y-2 text-sm text-muted">
          {[
            'Loja visível no mapa para todos os jogadores',
            'Ofertas ilimitadas com QR codes',
            'Validação de resgates em tempo real',
            'Analytics de desempenho',
            'Suporte por email',
          ].map((item) => (
            <li key={item} className="flex items-center gap-2">
              <span className="text-emerald-500">✓</span>
              {item}
            </li>
          ))}
        </ul>
      </div>

      {/* Pagamento em breve */}
      <div className="rounded-2xl border border-dashed border-edge bg-background p-6 text-center">
        <p className="text-2xl">💳</p>
        <p className="mt-2 font-bold text-fg">Pagamento online — Em breve</p>
        <p className="mt-1 text-sm text-muted">
          O sistema de pagamento automático está a ser preparado. Para ativar a tua subscrição, contacta-nos por email.
        </p>
        <a
          href="mailto:support@hakkencity.com"
          className="mt-4 inline-block rounded-xl bg-accent px-6 py-2.5 text-sm font-bold text-white hover:bg-accent"
        >
          Contactar suporte
        </a>
      </div>
    </div>
  );
}
